module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_an-instance.js
// module id = ./node_modules/core-js/library/modules/_an-instance.js
// module chunks = main